import axios from "axios";
import { configs } from "../app/app-configs";
import { SettingDefinition } from "./model/setting-definition.model";
import { Setting } from "./model/setting.model";

export const getSettingDefinitions = async (): Promise<SettingDefinition[]> => {
    return await axios.get(`${configs.BASE_URL}/setting-definitions`)
    .then(res => {
        return res.data as SettingDefinition[];
    });
}

export const getBusinessSettings = async (): Promise<Setting[]> => {
    return await axios.get(`${configs.BASE_URL}/business-settings`)
    .then(res => {
        return res.data as Setting[];
    });
}

export const updateBusinessSetting = async (request: Setting): Promise<Setting> => {
    return await axios.put(`${configs.BASE_URL}/business-settings`, request)
    .then(res => {
        return res.data as Setting;
    });
}
